module.exports = __webpack_public_path__ + "img/sociedad-chilena.7d90aa33.png";